export interface IResetPasswordRequest {
  password: string;
  passwordResetCode: string;
}

export class ResetPasswordRequest implements IResetPasswordRequest {
  password: string;
  passwordResetCode: string;
}
